export default __webpack_public_path__ + "static/apercu-medium-b705b78bc587e6d4bd016d4fda3752b1.eot";